// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"48af205a","351":"fe4ceaa2","382":"728dbdc7","720":"e2641918","849":"1f077933","937":"dd41bc6c"}[chunkId] + ".chunk.css";
};